import { Grid } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { getPalletItems } from "services/data.inbound.service";
import Drawer from "ui-components/Drawer";
import StickyHeadTable from "ui-components/tables/StickyTable";
import TimelineList from "ui-components/Timeline/TimelineList";
import TimelineItem from "ui-components/Timeline/TimelineItem";

const columns = [
  {
    label: "SKU Code",
    id: "skuCode",
  },
  {
    label: "Quantity",
    id: "quantity",
  },
  {
    label: "Pallet Number",
    id: "palletNbr",
  },
  {
    label: "Carton ID",
    id: "cartonID",
  },
  {
    label: "MLN",
    id: "mln",
  },
  {
    label: "Expiry Date",
    id: "expiryDate",
  },
   {
    label: "Zone ID",
    id: "zoneID",
  },
  {
    label: "Location ID",
    id: "locationID",
  },
  {
    label: "OLN",
    id: "oln",
  },
  {
    label: "Pack Type",
    id: "packType",
  },
];

function PalletItems({ open, setOpen, palletRequest, setPalletRequest }) {
  const [items, setItems] = useState(null);
  useQuery({
    queryKey: ["pallet-items", { palletRequest }],
    queryFn: () => getPalletItems(palletRequest),
    enabled: palletRequest !== null,
    onSuccess: (data) => {
      const item = data.data.data;
      const renderTimelineItems = item.logs.map(({ id, ...log }) => (
        <TimelineItem key={id} {...log} />
      ))
      setItems(
        <>
          <div style={{ fontSize: "14px", marginBottom: "20px" }}>
            <Grid container>
              <Grid item xs={6}>
                <b>Recv Code : </b>
                {item.details[0].recvCode}
              </Grid>
              <Grid item xs={6}>
                <b>Customer Code : </b>
                {item.details[0].customerCode}
              </Grid>
              <Grid item xs={6}>
                <b>Vendor Code : </b>
                {item.details[0].vendorCode}
              </Grid>
              <Grid item xs={6}>
                <b>Warehouse Code : </b>
                {item.details[0].warehouseCode}
              </Grid>
            </Grid>
          </div>
          <div>
            <StickyHeadTable columns={columns} rows={item.details} />
          </div>
          <TimelineList title="Logs">{renderTimelineItems}</TimelineList>
        </>
      );
    },
  });
  const toggleDrawer = (open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setOpen(open);
    setItems(null);
    setPalletRequest(null);
  };
  return (
    <Drawer width="800px" open={open} onClose={toggleDrawer(false)} onOpen={toggleDrawer(true)}>
      {items}
    </Drawer>
  );
}

export default PalletItems;
